import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IUserStatusProps {
  title: string;
  statuses: React.ReactNode[];
}

export const UserStatus = ({ title, statuses }: IUserStatusProps): React.JSX.Element => {
  return (
    <div className={styles['section']}>
      <div className={styles['subtitle']}>
        <UIText2>{title}</UIText2>
      </div>
      <div className={styles['ratings']}>
        {statuses.map((status, i) => {
          return (
            <div key={i} className={styles['rating']}>
              {status}
            </div>
          );
        })}
      </div>
    </div>
  );
};
